import React, { useEffect, useRef, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { track } from '../utils/analytics';
import './EmailAuth.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

/** Landing page for the emailed sign-in link: /login/verify/:token */
const VerifyEmail: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { refreshUser } = useAuth();
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  // A link works once, and React dev mode runs effects twice, so the call is guarded.
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    fetch(`${API_BASE}/auth/email/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ token }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.error || 'This link is not valid.');
        }
        await refreshUser();
        track('login', { method: 'email' });
        setDone(true);
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : 'Sign-in failed. Please request a new link.'));
  }, [token, refreshUser]);

  if (done) return <Navigate to="/dashboard" replace />;

  return (
    <div className="login-page-fullscreen">
      <div className="login-container">
        {error ? (
          <div className="ea-sent" role="alert">
            <h2>Link problem</h2>
            <p>{error}</p>
            <Link className="ea-btn" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none' }} to="/login">
              Back to sign in
            </Link>
          </div>
        ) : (
          <div className="ea-sent" role="status">
            <div className="spinner" />
            <p>Signing you in...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
